// Copyright (c) Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.

export enum RouterLinks {
  OVERVIEW = 'overview',
  GETTING_STARTED = 'getting-started',
  EXAMPLE_USAGE_HTML = 'using-ui-components-in-any-framework',
  EXAMPLE_NPM_USAGE_ANGULAR = 'using-ui-components-from-npm-package-in-angular',
  STYLING = 'styling',
  TROUBLESHOOTING = 'troubleshooting',
  CONVERT_COMPONENT = 'convert-component',
  MIGRATE_MODULES_TO_STANDALONE = 'migrate-modules-to-standalone',
  RELEASE_NOTES = 'release-notes',
  LF_BREADCRUMBS = 'lf-breadcrumbs',
  LF_CHECKLIST = 'lf-checklist',
  LF_TOOLBAR = 'lf-toolbar',
  LF_FIELD_CONTAINER = 'lf-field-container',
  LF_FIELD_TYPES = 'lf-field-types',
  LF_FIELD_ADHOC_CONTAINER = 'lf-field-adhoc-container',
  LF_FIELD_TEMPLATE_CONTAINER = 'lf-field-template-container',
  LF_LOGIN = 'lf-login',
  LF_USER_FEEDBACK = 'lf-user-feedback',
  LF_REPOSITORY_BROWSER = 'lf-repository-browser',
  LF_TAGS = 'lf-tags',
}
